import React, { Fragment } from 'react';
import { Box, Heading } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { getRoomType } from 'store/booking/bookingSelectors';
import Markup from 'components/Markup';
import FacilitiesList from 'components/FacilitiesList';

const RoomDescription = () => {
  const { description, roomTypeFacilities } = useSelector(getRoomType);
  return (
    <Fragment>
      <Box fontSize={['sm', 'base']} mt={4} data-testid="room-description">
        <Markup content={description} />
      </Box>
      <Box display="none" mt={4} data-print-style="visible">
        <Heading.h4>Room facilities</Heading.h4>
        <FacilitiesList fontSize={['sm', 'base']} facilities={roomTypeFacilities} />
      </Box>
    </Fragment>
  );
};

export default RoomDescription;
